(() => {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.helpers = window.Dashboard.helpers || {};

    class CommonHelper {

        findIndex(
            array,
            matcher
        ) {
            return array.reduce(
                (acc, cur, idx) => {
                    if (acc > -1) {
                        return acc;
                    }
                    return matcher(cur)
                        ? idx
                        : acc;
                }, -1
            );
        }

        zeroPad(value) {
            value = (value || "").toString();
            while (value.length < 2) {
                value = `0${value}`;
            }
            return value;
        }
    }

    window.Dashboard.helpers.commonHelper = new CommonHelper();
})();
